export const disclaimerFootnote2023Gql = `... on landingPageContent2023_disclaimerFootnote_BlockType{
  typeHandle
  disclaimerFootnote{
    ... on disclaimerFootnote_disclaimerFootnote_Entry{
      content:disclaimercontent
    }
  }
  colors
}`;
